module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_07-befc18db78f7ce5d28ca72065b50cee2.png";